import { Announced } from 'office-ui-fabric-react';
import React, { FunctionComponent, useCallback, useContext, useState } from 'react';
import styled from 'styled-components';

import { flexRow } from '../../Styles';
import { body1Font } from '../Typography/Typography';
import { toggleShowAll } from '../BasePaginationContainer/PaginationStore/actions';
import PaginationContext from '../BasePaginationContainer/PaginationStore/PaginationContext';
import { IPaginationHeadingProps } from './PaginationHeading.types';

const PaginationHeader = styled.div`
  ${flexRow}
  width:100%;
  justify-content: space-between;
`;

const PaginationHeaderText = styled.h2`
  color: rgb(50, 49, 48);
  letter-spacing: 0px;
  line-height: 24px;
  font-size: 20px;
  font-weight: normal;
`;

const ShowAllButton = styled.button`
  ${body1Font}
  background: none;
  border: none;
  padding: 0px;
  color: #069;
  text-decoration: none;
  cursor: pointer;
  &:focus {
    outline: black solid 1px;
  }
  &:active,
  &:hover {
    text-decoration: underline;
  }
`;

const StyledAnnounced = styled(Announced)`
  display: none;
`;

export const PaginationHeading: FunctionComponent<IPaginationHeadingProps> = props => {
  const { dispatch, showAll } = useContext(PaginationContext);
  const [ariaAnnouncement, setAriaAnnouncement] = useState('');
  const {
    headingText,
    onClickShowAll,
    showAllText = 'Show all',
    showLessText = 'Show less',
    showAll: showAllOverride = showAll,
    itemsName,
  } = props;

  const _onClickShowAll = useCallback(() => {
    const defaultFn = () => dispatch && dispatch(toggleShowAll()); //create defaultFn
    onClickShowAll ? onClickShowAll(undefined, defaultFn) : defaultFn(); //run click function
    if (itemsName) setAriaAnnouncement(`Displaying ${showAllOverride ? 'fewer' : 'more'} ${itemsName}`);
  }, [dispatch, onClickShowAll, showAllOverride, itemsName, setAriaAnnouncement]);

  let ariaLabel = '';
  if (itemsName) {
    ariaLabel = !showAllOverride ? `Show all ${itemsName}` : `Show fewer ${itemsName}`;
  }

  return (
    <PaginationHeader>
      <StyledAnnounced message={ariaAnnouncement} />
      <PaginationHeaderText>{headingText}</PaginationHeaderText>
      <ShowAllButton onClick={_onClickShowAll} aria-label={ariaLabel} aria-live="polite" className="showAllButton">
        {!showAllOverride ? showAllText : showLessText}
      </ShowAllButton>
    </PaginationHeader>
  );
};

export default PaginationHeading;
